/**
 * Section "Documents GED" (visualisation/téléchargement par membre).
 * Extrait de DocumentSections.js (refactor P2 — Feb 2026).
 */
import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { FolderOpen, Eye, Download } from 'lucide-react';
import { downloadDocument, viewDocument } from '../../services/downloadService';
import { getFileIcon, formatFileSize, getCategorieLabel } from './helpers';
import { RegenererRecuButton } from './RegenererRecuButton';

export default function GedSection({ items, membreId, onRefresh }) {
  if (!items?.length) return null;
  return (
    <div>
      <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <FolderOpen className="h-4 w-4 text-indigo-500" />Documents GED ({items.length})
      </h4>
      <div className="space-y-2">
        {items.map((doc) => (
          <div key={doc.id} className="flex items-center justify-between p-3 bg-indigo-50 rounded-lg border border-indigo-200">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white rounded-lg shadow-sm">{getFileIcon(doc.mime_type)}</div>
              <div>
                <p className="font-medium text-gray-900 text-sm">{doc.nom}</p>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <Badge variant="outline" className="text-indigo-600 border-indigo-300 text-xs py-0">
                    {getCategorieLabel(doc.categorie)}
                  </Badge>
                  {doc.file_size && <span>{formatFileSize(doc.file_size)}</span>}
                  {doc.date_creation && <span>• {new Date(doc.date_creation).toLocaleDateString('fr-FR')}</span>}
                </div>
                {doc.tags?.length > 0 && (
                  <div className="flex gap-1 mt-1">
                    {doc.tags.slice(0, 3).map((tag, idx) => (
                      <Badge key={idx} variant="secondary" className="text-xs py-0 px-1">{tag}</Badge>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="outline" className={`text-xs ${
                doc.status === 'valide' ? 'text-green-600 border-green-300' :
                doc.status === 'rejete' ? 'text-red-600 border-red-300' :
                'text-amber-600 border-amber-300'
              }`}>
                {doc.status === 'valide' ? 'Validé' : doc.status === 'rejete' ? 'Rejeté' : 'En attente'}
              </Badge>
              {(doc.url || doc.ged_id || doc.id) && (
                <>
                  <Button variant="outline" size="sm" className="border-indigo-300 text-indigo-700 hover:bg-indigo-100" onClick={() => viewDocument(doc)}>
                    <Eye className="h-4 w-4 mr-1" />Voir
                  </Button>
                  <Button variant="outline" size="sm" className="border-indigo-300 text-indigo-700 hover:bg-indigo-100" onClick={() => downloadDocument(doc)}>
                    <Download className="h-4 w-4 mr-1" />Télécharger
                  </Button>
                  <RegenererRecuButton doc={doc} membreId={membreId} onDone={onRefresh} />
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
